import React from 'react';
import Footer from "../components/Footer";
import BottomSection from "../components/BottomSection";
import ImgCard from "../components/ImgCard";
import docsImg from "../assets/images/Docs/docs_img.png";
import docsVideo from "../assets/images/4APIdocs.mp4";
import VideoPlayer from "../components/VideoPlayer";
function Docs(props) {

  const videos=[docsVideo];

  return (
      <div id={'Docs'}>
        <ImgCard title={'MOST POWERFUL FEATURE FOR WEB3'} description={'START YOUR BUSINESS QUICKLY WITH VERIA HUB\'S PROVEN WEB3 SOLUTION. WE PROVIDE EVERYTHING YOU NEED, INCLUDING APIS, SMART CONTRACTS, DASHBOARD ETC'} img={docsImg}
                 cardTitle1={'REST API'} cardSubTitle1={'INSTEAD OF COMPLEX PROTOCOLS LIKE RPC, WE PROVIDE STANDARD REST APIS'}
                 cardTitle2={'WEBHOOK'} cardSubTitle2={'STOP POLLING AND HANDLE BLOCKCHAIN WITH AN EVENT-DRIVEN APPROACH'}
                 cardTitle3={'FUNCTIONAL'} cardSubTitle3={"WITH A FOCUS ON FUNCTIONAL UNITS, IT'S EASY TO START YOUR BUSINESS"}
                 cardTitle4={'EASY & SIMPLE'} cardSubTitle4={'ENCOURAGE DEVELOPERS TO PARTICIPATE IN THE ECOSYSTEM WITH WELL-ORGANIZED DOCUMENTATION'}
        />
        <VideoPlayer title={'LIVE DEMONSTRATION VIDEO'}
                     description={'THIS IS A COLLECTION OF DEMONSTRATION VIDEOS THAT ALLOW YOU TO SEE AT A GLANCE THE VARIOUS SOLUTIONS OFFERED BY VERIA DOCS'}
                     videos={videos}
        />
        <BottomSection title={'RUN YOUR WEB3 BUSINESS WITH VERIA DOCS'} description={'CUSTOMIZED SOLUTIONS AND VARIOUS SUPPORT FOR ENTERPRISES'} cardText={'VERIA HUB COLLABORATES WITH GLOBAL ENTERPRISES TO PROMOTE WEB3 ADOPTION AND BLOCKCHAIN COMMERCIALIZATION. WE PROVIDE VARIOUS BLOCKCHAIN-BASED SOLUTIONS INCLUDING STO, WEB3 PAYMENTS, POINTS, AND VOUCHERS, AND WELCOME NEW PARTNERSHIPS.'}/>
        <Footer/>
      </div>
  );
}

export default Docs;